import { Edit03Icon } from '@hugeicons/core-free-icons';
import { IconButton, Tooltip } from '@sunrise-ui/primitives';
import React, { useState } from 'react';
import type { ViewStyle } from 'react-native';
import { SessionEditModal } from './SessionEditModal';

type Props = {
  canEdit: boolean;
  sessionId: string;
  eventId: string;
  communityId?: string;
  style?: ViewStyle;
};

export function SessionEditButton({
  canEdit,
  sessionId,
  eventId,
  communityId,
  style,
}: Props) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  if (!canEdit) {
    return null;
  }

  return (
    <>
      <Tooltip title="Edit">
        <IconButton
          icon={Edit03Icon}
          onPress={() => {
            setIsEditModalOpen(true);
          }}
          size="small"
          style={style}
        />
      </Tooltip>
      {isEditModalOpen && (
        <SessionEditModal
          isOpen={isEditModalOpen}
          setIsOpen={setIsEditModalOpen}
          sessionId={sessionId}
          eventId={eventId}
          communityId={communityId}
        />
      )}
    </>
  );
}
